import SafeImage from '@ui/SafeImage';
import Link from 'next/link';
import React from 'react';
import { clickBlogAd } from '@util/analytics';

const BlogNativeAd = ({
  id,
  src,
  href,
  title,
  vendor
}: {
  id: string;
  src: string;
  href: string;
  title: string;
  vendor: string;
}) => {
  return (
    <Link
      href={href}
      title={title}
      target="_blank"
      onClick={() => clickBlogAd(id, 'block', title, href, vendor)}
      className="flex w-full flex-col items-center gap-[1.6rem]"
    >
      {/* image */}
      <div className="relative h-[22rem] w-full min-w-[31rem] self-start overflow-clip sm:h-[25rem]">
        <SafeImage
          alt={title}
          src={src}
          fill={true}
          style={{ objectFit: 'cover' }}
        />

        {/* bottom right */}
        <div className="absolute bottom-4 right-4 text-right text-brand-white">
          <div className="text-[3.2rem] font-semibold">{}</div>
          <div className="font-medium opacity-80"></div>
        </div>
      </div>
      {/* info */}
      <div className="grow">
        <div className="flex w-full flex-col text-left sm:gap-[.4rem]">
          <p className="text-[1.8rem] font-semibold text-brand-secondary">{}</p>
          <p className="text-brand-lightest-black">{}</p>
        </div>
      </div>
    </Link>
  );
};

export default BlogNativeAd;
